<template>
    <vx-card class="list-view-item mb-base overflow-hidden">

        <template slot="no-body">
            <div class="vx-row item-details no-gutter">

                <!-- GRAPH -->
                <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center">
									<statistics-card-line
										icon="UsersIcon"
										:statistic="'ID: ' + item.participant_id"
										statisticTitle="Pathology"
										:chartData="chartData"
                    :graphHeight=270
										type='area'></statistics-card-line>
                </div>

                <!-- ITEM NAME & DESC COL -->
                <div class="vx-col sm:w-1/2">
                    <div class="p-4 pt-6">
                        <slot name="item-meta">
                            <h5 class="item-name font-semibold mb-1 px-4">
                              {{item.list_study_name}}
                              <vs-avatar size="small" text="M" color="primary" v-if="item.gender_id==1" />
                              <vs-avatar size="small" text="F" color="success" v-if="item.gender_id==2" />
                              <vs-avatar size="small" text="NA" v-if="item.gender_id==3" />
                            </h5>
                            <p class="text-sm mb-4 cursor-pointer px-4">
                              <span>Patient ID: {{item.participant_id}}</span>
                            </p>

                            <div class="vx-row item-details no-gutter">
                              <div class="vx-col sm:w-1/2 px-4">
                                <h6>Pathology</h6>
                                <p class="item-description text-sm">
                                  {{item.pathology_date_first}} - {{item.pathology_date_last}}
                                  <br />
                                  {{item.age_follow_up_pathology}}
                                  <br />
                                  {{item.total_pathology}} records
                                  <br />
                                  <br />
                                </p>
                                <div class="bg-primary flex text-white py-1 px-2 rounded">
                                  <span class="text-sm mr-2">{{arrPathologyGrade.join(', ')}}</span>
                                </div>
                              </div>
                              <div class="vx-col sm:w-1/2 px-4 flex flex-col w-full border border-solid border-grey-light border-r-0 border-t-0 border-b-0">
                                <h6>Endoscopy</h6>
                                <p class="item-description text-sm">
                                  {{item.endoscopy_date_first}} - {{item.endoscopy_date_last}}
                                  <br />
                                  {{item.age_follow_up_endoscopy}}
                                  <br />
                                  {{item.total_endoscopy}} records
                                  <br />
                                  <br />
                                </p>
                                <div class="bg-primary flex text-white py-1 px-2 rounded">
                                  <span class="text-sm mr-2">
                                    C{{barrettsCircumferenceMax}} (max)
                                    M{{barrettsMaximumMax}} (max)
                                  </span>
                                </div>
                              </div>
                            </div>
                        </slot>
                    </div>

                    <!-- SLOT: ACTION BUTTONS -->
                    <div class="p-0">
                      <slot name="action-buttons" />
                    </div>
                </div>

                <!-- GRAPH -->
                <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center">
									<statistics-card-line
										icon="UsersIcon"
										:statistic="'ID: ' + item.participant_id"
										statisticTitle="Endoscopy"
										:chartData="chartData2"
                    :graphHeight=270
										type='area'></statistics-card-line>
                </div>
            </div>
        </template>

    </vx-card>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default{
    data() {
      return {
        chartData: {
            series: [],
            chartOptions: {
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
                chart: {
                    type: 'area',
                    toolbar: {
                        show: false,
                    },
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2.5
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 0.9,
                        opacityFrom: 0.7,
                        opacityTo: 0.5,
                        stops: [0, 80, 100]
                    }
                },
                xaxis: {
                    type: 'category',
                    lines: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                    labels: {
                      show: true,
                      format: 'DD/MM',
                    }
                },
                yaxis: [{
                    y: 0,
                    offsetX: 0,
                    offsetY: 0,
                    min: 0,
	                  max: 9,
                    padding: { left: 0, right: 0 },
                }],
                tooltip: {
                    x : {
                      show: true,
                      formatter: function(value, timestamp) {
                        const thisDate = new Date(value);
                        return thisDate.getDate() + '/' + (thisDate.getMonth()+1) + '/' + thisDate.getFullYear();
                      },
                    },
                    y : {
                      show: true,
                      formatter: function (value) {
                        switch(value) {
                          case -10: return 'Not specified (-10)'; break;
                          case -4: return 'HGD (-4)'; break;
                          case -3: return 'LGD (-3)'; break;
                          case -1: return 'Normal squamous (-1)'; break;
                          case 0: return 'Not specified (0)'; break;
                          case 1: return 'Normal Squamous (1)'; break;
                          case 2: return 'Gastric metaplasia (2)'; break;
                          case 3: return 'Cardia IM (3)'; break;
                          case 4: return 'Barretts No Dysplasia (4)'; break;
                          case 5: return 'Indefinite For Dysplasia (5)'; break;
                          case 6: return 'LGD (6)'; break;
                          case 7: return 'HGD (7)'; break;
                          case 8: return 'Intramucosal carcinoma (8)'; break;
                          case 9: return 'Carcinoma (9)'; break;
                        } //switch
                      },
                    }

                },
            },
        },
        chartData2: {
            id: 'endoscopy',
            series: [],
            chartOptions: {
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2.5
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 0.9,
                        opacityFrom: 0.7,
                        opacityTo: 0.5,
                        stops: [0, 80, 100]
                    }
                },
                xaxis: {
                    type: 'category',
                    lines: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                    labels: {
                      show: true,
                      format: 'DD/MM',
                    }
                },
                yaxis: [{
                    y: 0,
                    offsetX: 0,
                    offsetY: 0,
                    padding: { left: 0, right: 0 },
                }],
                tooltip: {
                    x : {
                      show: true,
                      formatter: function(value, timestamp) {
                        const thisDate = new Date(value);
                        return thisDate.getDate() + '/' + (thisDate.getMonth()+1) + '/' + thisDate.getFullYear();
                      },
                    },
                    y : {
                      show: true,
                      formatter: function(value) {
                        return value;
                      }
                    }

                },
            },
        },
        arrPathologyGrade: [],

        // Endoscopy
        barrettsCircumferenceMax: 0,
        barrettsMaximumMax: 0,
      }
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        graphType: {
						type: String,
						required: false
				},
    },
    components: {
        StatisticsCardLine,
    },
    computed: {
        isInCart() {
            return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
        },
        isInWishList() {
            return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
        },
    },
    methods: {
      extractPathologyData() {
        if (this.item.list_pathology_date_grade==''){ return; }

        const arrPathology = this.item.list_pathology_date_grade.split(',');
        const arrPathologyProv = this.item.list_pathology_date_grade_prov.split(',');
        const arrPathologyResearch = this.item.list_pathology_date_grade_research.split(',');

        let arrPathologyDate = [];
        let arrPathologyGradeId = [];
        let arrPathologyFormattedData = [];
        let arrPathologyFormattedDataProv = [];
        let arrPathologyFormattedDataResearch = [];

        let objPathologyGradeId = {}; //Unique grades

        for(let i = 0; i < arrPathology.length; i++) {
          let pathology = arrPathology[i];
          arrPathologyDate.push(pathology.split('|')[0]);
          arrPathologyGradeId.push(pathology.split('|')[1]);

          objPathologyGradeId[pathology.split('|')[1]] = 1;

          let pathologyDate = pathology.split('|')[0];
          let pathologyTimeStamp = new Date(pathologyDate.split('-')[1] + "," + pathologyDate.split('-')[2] + "," + pathologyDate.split('-')[0]).getTime();
          arrPathologyFormattedData.push([
            pathologyTimeStamp,
            pathology.split('|')[2]
          ]);
          arrPathologyFormattedDataProv.push([
            pathologyTimeStamp,
            arrPathologyProv[i].split('|')[2]
          ]);
          arrPathologyFormattedDataResearch.push([
            pathologyTimeStamp,
            arrPathologyResearch[i].split('|')[2]
          ]);
        }

        this.chartData.series = [
          {
            name: 'Confirmed',
            data: arrPathologyFormattedData
          },
          {
            name: 'Prov',
            data: arrPathologyFormattedDataProv
          },
          /*
          {
            name: 'Research',
            data: arrPathologyFormattedDataResearch
          },
          */
        ];

        // get distinct list of dysplasia grades
        this.formatDisplayPathologyGradeIdList(objPathologyGradeId);
      },
      extractEndoscopyData() {
        if (this.item.list_endoscopy_date_cm==''){ return; }

        const arrEndoscopy = this.item.list_endoscopy_date_cm.split(',');
        let arrEndoscopyFormattedData = [];

        let arrEndoscopyXCategories = [];
        let arrEndoscopyFormattedDataC = [];
        let arrEndoscopyFormattedDataM = [];

        for(let i = 0; i < arrEndoscopy.length; i++) {
          let endoscopy = arrEndoscopy[i];
          let endoscopyDate = endoscopy.split('|')[0];
          let endoscopyTimeStamp = new Date(endoscopyDate.split('-')[1] + "," + endoscopyDate.split('-')[2] + "," + endoscopyDate.split('-')[0]).getTime();

          let endoscopyPragueC = endoscopy.split('|')[1].split(':')[1];
          let endoscopyPragueM = endoscopy.split('|')[2].split(':')[1];

          arrEndoscopyXCategories.push(endoscopyTimeStamp);
          arrEndoscopyFormattedDataC.push([endoscopyTimeStamp, endoscopyPragueC]);
          arrEndoscopyFormattedDataM.push([endoscopyTimeStamp, endoscopyPragueM]);

          if (parseInt(endoscopyPragueM) > this.barrettsMaximumMax ) { this.barrettsMaximumMax = parseInt(endoscopyPragueM); };
          if (parseInt(endoscopyPragueC) > this.barrettsCircumferenceMax ) { this.barrettsCircumferenceMax = parseInt(endoscopyPragueC); };
        }

        this.chartData2.series = [
          {
            name: 'C',
            data: arrEndoscopyFormattedDataC
          },
          {
            name: 'M',
            data: arrEndoscopyFormattedDataM
          },
        ];
      },
      formatDisplayPathologyGradeIdList(objPathologyGradeId) {
        const arrPathologyGradeId = Object.keys(objPathologyGradeId);
        // console.log(arrPathologyGradeId);

        for(let i = 0; i < arrPathologyGradeId.length; i++) {
          this.arrPathologyGrade.push(this.pathologyGradeFromId(parseInt(arrPathologyGradeId[i], 10)));
        }
      },
      pathologyGradeFromId(pathologyGradeId) {
        switch(pathologyGradeId) {
          case 1:
            return 'Normal Squamous';
          break;
          case 2:
            return 'Barretts No Dysplasia';
          break;
          case 3:
            return 'Indefinite For Dysplasia';
          break;
          case 4:
            return 'LGD';
          break;
          case 5:
            return 'HGD';
          break;
          case 6:
            return 'Carcinoma';
          break;
          case 7:
            return 'Not specified';
          break;
          case 8:
            return 'Intramucosal carcinoma';
          break;
          case 9:
            return 'IM';
          break;
          case 10:
            return 'Gastric metaplasia';
          break;
          case 11:
            return 'Normal squamous';
          break;
          case 12:
            return 'Squamous hyperplasia';
          break;
          case 13:
            return 'LGD';
          break;
          case 15:
            return 'HGD';
          break;
          case 16:
            return 'Intramucosal m1-2';
          break;
          case 17:
            return 'Intramucosal m3';
          break;
          case 18:
            return 'Invasive Carcinoma';
          break;
          case 19:
            return 'Not specified';
          break;
        } //switch
      },
        toggleItemInWishList(item) {
            this.$store.dispatch('eCommerce/toggleItemInWishList', item)
        },
        additemInCart(item) {
            this.$store.dispatch('eCommerce/additemInCart', item)
        },
        cartButtonClicked(item) {
            if(this.isInCart(item.objectID)) this.$router.push('/apps/eCommerce/checkout')
            else this.additemInCart(item)
        }
    },
    mounted() {
			this.extractPathologyData();
			this.extractEndoscopyData();
		},
}
</script>

<style lang="scss" scoped>
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
